import { useQuery } from '@tanstack/react-query'
import { createAuthClient } from 'better-auth/react'
import { api } from '../lib/api'

/** The admin app's own sign-in (its host, its cookies): same-origin /api/auth, answered by the admin auth instance. */
export const adminAuthClient = createAuthClient({ baseURL: window.location.origin, basePath: '/api/auth' })

export type AdminRole = 'super_admin' | 'admin' | 'viewer'
export const ADMIN_ROLE_LABEL: Record<AdminRole, string> = { super_admin: 'Super admin', admin: 'Admin', viewer: 'Viewer' }

export interface AdminSession {
  user: { id: string; email: string; name: string; image?: string | null } | null
  role: AdminRole | null
  google: boolean
  consoleUrl: string
}

export const useAdminSession = () => useQuery({ queryKey: ['admin-session'], queryFn: () => api<AdminSession>('/api/admin/session') })

const RANK: Record<AdminRole, number> = { viewer: 1, admin: 2, super_admin: 3 }

/** What the signed-in admin may do (the API enforces the same): `can('admin')` to change things, `can('super_admin')` for the team and settings. */
export function useAdminCan(): (min: AdminRole) => boolean {
  const role = useAdminSession().data?.role
  return (min) => !!role && RANK[role] >= RANK[min]
}
